import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router";
import { useClientSession } from "../hooks/useClientSession";
import { setBehaviorIdentity, startBehaviorTracker, trackPageChange } from "./tracker";

export function BehaviorRoot({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { session } = useClientSession();

  useEffect(() => startBehaviorTracker(), []);

  useEffect(() => {
    setBehaviorIdentity({
      userId: session.id,
      userName: session.nickname || session.phone || session.email,
      userPlan: session.plan,
    });
  }, [session.email, session.id, session.nickname, session.phone, session.plan]);

  useEffect(() => {
    trackPageChange(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return children;
}
